import { AppShell } from '@mantine/core';
import { createAddUserModal } from 'features/add-user';
import { createBlockUserModal } from 'features/block-user';
import { createDeleteUserModal } from 'features/delete-user';
import { createEditUserModal } from 'features/edit-user';
import { createUnblockUserModal } from 'features/unblock-user';
import { createUserRegistry } from 'entities/user';
import { usersPageModel } from '../../model';
import cls from './users-page.module.scss';

const UserRegistry = createUserRegistry(usersPageModel.userRegistryModel);

const AddUserModal = createAddUserModal(usersPageModel.addUserModel);

const EditUserModal = createEditUserModal(usersPageModel.editUserModel);

const BlockUserModal = createBlockUserModal(usersPageModel.blockUserModel);

const UnblockUserModal = createUnblockUserModal(usersPageModel.unblockUserModel);

const DeleteUserModal = createDeleteUserModal(usersPageModel.deleteUserModel);

export const UsersPage = () => (
	<>
		<AppShell.Main className={cls.usersPage}>
			<UserRegistry
				className={cls.usersPageUserRegistry}
				emptyActionSlot={<AddUserModal.Button />}
				topBarActionSlot={<AddUserModal.Button />}
				tableTdActionSlot={(user) => (
					<div className={cls.usersPageActions}>
						<EditUserModal.ActionIcon modalData={user} />
						{user.isLocked ? (
							<UnblockUserModal.ActionIcon modalData={user} />
						) : (
							<BlockUserModal.ActionIcon modalData={user} />
						)}
						<DeleteUserModal.ActionIcon modalData={user} />
					</div>
				)}
			/>
		</AppShell.Main>
		<EditUserModal />
		<DeleteUserModal />
		<BlockUserModal />
		<UnblockUserModal />
		<AddUserModal />
	</>
);
